export default () => ({
  notificationsSettings: {},
  notifications: [],
  unseenNotificationsCount: 0,
  notificationsCount: 0,
  currentNotificationsPage: 1,
  notificationsBadgeVisibility: true
})
